import axios from "axios";

// Update with your actual API URL
const API_URL = "https://ims.holdthechild.net";

/**
 * Fetches all dashboard statistics from the backend.
 * This includes user counts, growth data, and status breakdown.
 * @returns {Promise<Object>} An object containing all dashboard data.
 */
export async function fetchDashboardData() {
    try {
        const token = localStorage.getItem("token");
        if (!token) {
            throw new Error("No authorization token found.");
        }

        const response = await axios.get(`${API_URL}/api/dashboard/stats`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        // The backend response object contains multiple data sets
        return response.data;
    } catch (error) {
        console.error("Error fetching dashboard data:", error?.response?.data || error.message);
        throw error;
    }
}